import React from "react";
import NFLookupEmptyForms from "../../../Shared/NewForms/NFLookupEmptyForms";

const AccountingManualTransactionsGenericSkeleton = () => {
  return (
    <>
      <NFLookupEmptyForms />
    </>
  );
};

export default AccountingManualTransactionsGenericSkeleton;
